import { render, staticRenderFns } from "./CheckIcons.vue?vue&type=template&id=f0fdd07c&scoped=true&"
import script from "./CheckIcons.vue?vue&type=script&lang=ts&"
export * from "./CheckIcons.vue?vue&type=script&lang=ts&"
import style0 from "./CheckIcons.vue?vue&type=style&index=0&id=f0fdd07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fdd07c",
  null
  
)

export default component.exports